const GELADA_JWT_KEYS = ['_v', 'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata', 'token_type'] as const;

const TOKEN_IS_REQUIRED = 'A token is required';

export { GELADA_JWT_KEYS, TOKEN_IS_REQUIRED };
